const setAuthentication = ({full_name, username, user_id, role, accessToken, expires_in, id}) => {
    console.log(accessToken, id);
    localStorage.setItem('Authenticated', true);
    localStorage.setItem('full_name', JSON.stringify(full_name));
    localStorage.setItem('username', JSON.stringify(username));
    localStorage.setItem('user_id', JSON.stringify(user_id));
    localStorage.setItem('role', JSON.stringify(role));
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('id', id);
    localStorage.setItem('expires_in', JSON.stringify(expires_in));
};

const removeTokens = () => {
    localStorage.removeItem('Authenticated');
    localStorage.removeItem('full_name');
    localStorage.removeItem('username');
    localStorage.removeItem('user_id');
    localStorage.removeItem('role');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('expires_in');
};
const getAuthenticated = () => localStorage.getItem('Authenticated');
const getfull_name = () => localStorage.getItem('full_name');
const getusername = () => localStorage.getItem('username');
const getuser_id = () => localStorage.getItem('user_id');
const getrole = () => localStorage.getItem('role');
const seaccessToken = () => localStorage.setItem('accessToken');
const getexpires_in = () => localStorage.getItem('expires_in');

module.exports = {
    setAuthentication, 
    removeTokens, 
    getAuthenticated, 
    getfull_name, 
    getusername, 
    getuser_id,
    getrole,
    seaccessToken,
    getexpires_in
};
